import { component } from 'picoapp';
import getClient from './sanity';
import Marquee3k from 'marquee3000';
import moment from 'moment';

export default component((node, ctx) => {
  console.log('recentCreations');

  const render = node.querySelector('.js-recent-creations');
  const getCreations = async () => {
    const client = await getClient();
    const query = `*[_type == "creation"] | order(_createdAt desc)[0..9]`;

    client.fetch(query, {}).then(_creations => {
      const creations = _creations.sort(() => 0.5 - Math.random());
      console.log('~', creations);
      let html = '';
      let product = '';

      creations.forEach(creation => {
        if (creation.type === 'blush') {
          product = `
          <div class="">
            <div class="relative">
              <div class="w-[80%] h-[80%] absolute top-[10%] left-[10%]" style="border-radius: 100%; background-color: ${creation.hex}">&nbsp;</div>
              <img loading="lazy" src="${node.dataset.blush}" class="max-h-[120px] sm:max-h-[226px] h-full relative object-contain" />
            </div>
          </div>
          `;
        }

        if (creation.type === 'lipgloss') {
          product = `
          <div class="">
            <div class="relative">
              <div class="w-[95%] h-[86%] absolute top-[10%] left-[2.5%]" style="background-color: ${creation.hex}">&nbsp;</div>  
              <img loading="lazy" src="${node.dataset.lipgloss}" class="h-full max-h-[170px] sm:max-h-[300px] relative object-contain" />
            </div>
          </div>
          `;
        }

        const createdAt = moment(creation._createdAt).format('MMMM Do YYYY');

        const urlParameters = new URLSearchParams({
          name: creation.name,
          color: creation.hex.replace('#', ''),
        });

        const separator = creation.url.includes('?') ? '&' : '?';
        const url = `${creation.url}${separator}${urlParameters}`;

        let name = creation.name;
        if (name.includes(' ')) {
          const split = name.split(' ');
          const lastWord = split[split.length - 1];
          name = name.replace(lastWord, `<i>${lastWord}</i>`);
        }

        let createdBy = '';
        if (creation.createdByFirstName && !creation.createdByFirstName.includes('undefined')) {
          createdBy = `<div class="heading-4 mt-[10px]"><i>by</i> ${creation.createdByFirstName}</div>`;
        }
        else if (creation.createdBy && !creation.createdBy.includes('undefined')) {
          createdBy = `<div class="heading-4 mt-[10px]"><i>by</i> ${creation.createdBy}</div>`;
        }
        
        html += `
          <div class="text-center h-[100%]" style="background-color: rgba(255, 0, 0, 0)">
            <div class="flex flex-col h-full">  
              <a href="${url}" class="aspect-square relative flex items-center justify-center">
                ${product}
              </a>
              <div class="flex flex-col justify-between items-center flex-1">
                <div class="heading-4 mt-[20px]">${name}</div>
                ${createdBy}
                <a href="${url}" class="button--ghost button--s mt-[15px]">Create Your Own</a>
              </div>
            </div>

          </div>
        `;
      });
      render.innerHTML = html;
      setTimeout(() => {
        // Marquee3k.init({
        //   selector: 'scroller',
        // });
        // Marquee/3k.refreshAll();
        console.log('recent creations marquee');
      }, 0);
    });
  };

  getCreations();
});
